import { Link } from "react-router-dom";

function About() {
  return (
  <main id="main">

  <div className="page-header">
    <svg viewBox="0 0 100 100" className="page-header__seal" aria-hidden="true" style={{color:'#fff'}}>
      <circle cx="50" cy="50" r="47" fill="none" stroke="currentColor" strokeWidth="0.8"/>
      <path id="sealTopB" d="M 14,50 A 36,36 0 1,1 86,50" fill="none"/>
      <text fontSize="5.4" letterSpacing="1.5" fill="currentColor"><textPath href="#sealTopB" startOffset="50%" textAnchor="middle">JUSTICE FOR ALL</textPath></text>
    </svg>
    <div className="container">
      <div className="breadcrumb"><Link to="/">Home</Link> / About Us</div>
      <h1>About the Authority</h1>
      <p>The Legal Aid and Justice Authority (LAJA) is a statutory body established by the Government of Pakistan under the Legal Aid and Justice Authority Act, 2020. Headquartered in Islamabad, the Authority is mandated to operate across the entire country to ensure that the constitutional right to a fair trial and due process is not hindered by financial or social barriers. LAJA was founded to provide essential legal, financial, and ancillary assistance to the poor and vulnerable segments of society especially women and juvenile. Our primary focus is ensuring access to justice in criminal cases for those who cannot afford legal representation or the costs associated with the judicial process. We provide assistance to any applicant including minors and persons of unsound mind who is charged with a criminal offense and lacks the means to afford legal help. In all our operations, the Authority grants special preference to disadvantaged women and children, particularly those involved in cases related to sexual offenses.</p>
    </div>
  </div>

  <section className="section" style={{background:'#EFEAE0'}}>
    <div className="container">
      <div className="two-col">
        <div>
          <img src="/images/dg-msg.jpg" alt="img" style={{borderRadius:'8px'}}/>
        </div>
        <div>
          <span className="eyebrow" style={{color:'#A6781E'}}>MESSAGE FROM THE DIRECTOR GENERAL (LAJA)</span>
          <h3 style={{marginTop:'.5em'}}>ADIL ANWAR</h3>
          <p style={{ textAlign: 'justify'}}>The Legal Aid and Justice Authority (LAJA) was established with a clear mission: to ensure equal access to justice for all citizens, regardless of their socio-economic status. LAJA is committed to delivering transparent, efficient, and people-focused legal aid services across Pakistan. We remain dedicated to working with government institutions, the legal community, and civil society to build a more inclusive and accessible justice system.</p>
          <p style={{ textAlign: 'justify'}}>Our primary focus is to ensure access to justice in criminal cases and cases involving sexual offenses, with special preference given to disadvantaged women, children, and individuals who cannot afford legal representation or the costs associated with the judicial process.</p>
        </div>
      </div>
    </div>
  </section>

  <section className="section">
    <div className="container">
      <div className="two-col">
        <div>
          <span className="eyebrow">Our mission</span>
          <h2 style={{marginTop:'.5em'}}>No citizen shall be denied justice for lack of means.</h2>
          <p style={{ textAlign: 'justify'}}>To ensure a society where justice is accessible to all, regardless of financial status, and where the constitutional rights to a fair trial and due process are upheld for the most vulnerable segments of the population. LAJA provides legal, financial, and advisory services to ensure all citizens, especially women and juveniles, have equal access to justice. It also works to strengthen legal awareness.</p>
        </div>
        <div>
          <span className="eyebrow">Our vision</span>
          <h2 style={{marginTop:'.5em'}}>A justice system that is accessible, affordable, and timely.</h2>
          <p style={{ textAlign: 'justify'}}>The Authority was established to provide legal, financial, and other assistance to ensure access to justice for the poor and vulnerable segments of society especially women and juvenile, in criminal cases. It aims to support those unable to afford representation and to promote a right to a fair trial.</p>
        </div>
      </div>
    </div>
  </section>

  <section className="section section--alt">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">Milestones</span><h2>History of the Authority</h2></div>
      </div>
      <div className="timeline">
        <div className="timeline-item">
          <span className="timeline-item__year">2020</span>
          <h3>Authority constituted</h3>
          <p>Established under the governing Act to monitor and evaluate the implementation of legal aid programmes nationwide.</p>
        </div>
        <div className="timeline-item">
          <span className="timeline-item__year">2026</span>
          <h3>Recruitment of Staff</h3>
          <p>Staff recruitment was initiated nationwide in 2026 to strengthen legal aid services and ensure effective access to justice across the country.</p>
        </div>
        <div className="timeline-item">
          <span className="timeline-item__year">2026</span>
          <h3>District-Wise Legal Aid Services Started in 2026</h3>
          <p>Legal aid services were initially promoted district-wise from Rawalpindi & Islamabad to make legal assistance more accessible to local communities.</p>
        </div>

        <div className="timeline-item">
          <span className="timeline-item__year">2026</span>
          <h3>Para-legal Volunteer programme launched</h3>
          <p>Trained community volunteers began bridging the gap between citizens and the formal legal aid system.</p>
        </div>
        <div className="timeline-item">
          <span className="timeline-item__year">2026</span>
          <h3>Online complaint &amp; application portal</h3>
          <p>Citizens can now register complaints and applications for legal aid digitally, from any district.</p>
        </div>
      </div>
    </div>
  </section>

  <section className="section">
    <div className="container">
      <div className="section__head">
        <div><span className="eyebrow">Leadership</span><h2>Authority members</h2></div>
      </div>
      <div className="people-grid">
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/dg-laja.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Adil Anwar</h4>
          <span>Director General</span>
        </div>
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/murtaza-khan.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Ghulam Murtaza Khan</h4>
          <span>Deputy Director Legal Aid</span>
        </div>
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/akhtar-khan.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Akhtar Khan</h4>
          <span>Deputy Director Finance</span>
        </div>
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/yasir-jamal.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Yasir Jamal</h4>
          <span>IT/Network Administrator</span>
        </div>
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/waleed-zubair.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Waleed Zubair</h4>
          <span>Private Secretary</span>
        </div>
        <div className="person-card">
          <div className="person-card__photo"><img src="/images/about/sohail-khan.jpg" alt="img" width='100%' height='100%' /></div>
          <h4>Sohail Khan</h4>
          <span>Assistant (Admin)</span>
        </div>
      </div>
    </div>
  </section>

  {/* <section className="cta-banner">
    <div className="container">
      <div>
        <h2>Want to know more about how we work?</h2>
        <p>Our annual reports and governing Act are available in the downloads library.</p>
      </div>
      <div style={{display:'flex', gap:'14px', flexWrap:'wrap'}}>
        <a href="downloads.html" className="btn btn--gold">View Downloads</a>
      </div>
    </div>
  </section> */}

</main>
  );
}

export default About;
